// extracted by mini-css-extract-plugin
export default {"slots_item":"TimeSlot_slots_item__NC8J0","selected":"TimeSlot_selected__ijFsa","time":"TimeSlot_time__N0mfQ","text":"TimeSlot_text__RBcYr"};